<template>
  <section class="container-fluid">

    <!--        top title -->
    <div class="top-title">
      <h1 class="text-center logo-themed-header">
        <LogoSvg class="logo-icon" color="#e1bb28"></LogoSvg>
        <span class="text-my-oscar-list">MY<span class="text-oscar">OSCAR</span>LIST</span>
      </h1>
      <span class="header-subtitle">Build your checklist. Track your progress.<br>Discover what you’ve missed.</span>
    </div>

    <!--        checklist -->
    <div class="mol-center-card-width feature-section feature-section-checklist">
      <h4 class="feature-section-title text-my-oscar-list"><img :src="`${$imagePathBase}win_icon.svg`" alt="Logo" class="logo-image">MARK<span class="text-oscar">YOUR</span>FILMS</h4>
      <p class="text-center">
        Track every Oscar-nominated film you’ve seen.<br>
      </p>
      <ColorThemeImg class="checklist-image" :src="`${$imagePathBase}about/checklist.png`" :dark_theme_src="`${$imagePathBase}about/checklist-dark.png`"/>
      <div class="checklist-bullet-list">
        <p>
          <span class="btn btn-outline-secondary btn-sm" style="margin: 0; padding: 0; width: 16px; height: 16px; position: relative; pointer-events: none;">
            <span style="position: absolute; top: 0px; left: 0px;" class="fa fa-check" aria-hidden="true"></span>
          </span> Check the films you've seen.
        </p>
        <p><i class="fa fa-bookmark" style="color: coral; margin-left: 2.285px; margin-right: 2.285px"/> Bookmark the ones you want to watch next.</p>
        <p><img class="checkmark-image" style="border-style: solid; border-width: thin; border-color: var(--bs-secondary-color); border-radius: 50%;" :src="`${$imagePathBase}about/friend.png`"/> See which films your friends have seen.</p>
      </div>
      <p class="log-in-to-get-started-now">
        <router-link
            class="login-link"
            :to="{ name: defaultCreateAccount? 'SignUpPage' : 'LogInPage'}"
            v-text="defaultCreateAccount? 'Sign up' : 'Sign in'">
        </router-link> to get started now.
      </p>
    </div>


    <!--        dashboard -->
    <div class="mol-center-card-width feature-section feature-section-dashboard">
      <h4 class="feature-section-title text-my-oscar-list"><img :src="`${$imagePathBase}win_icon.svg`" alt="Logo" class="logo-image">TRACK<span class="text-oscar">YOUR</span>PROGRESS</h4>
      <p class="dashboard-text">
        View your dashboard, featuring unique fitness-ring style progression meters and achievements.
      </p>
      <ColorThemeImg class="dashboard-image" :src="`${$imagePathBase}about/dashboard.png`" :dark_theme_src="`${$imagePathBase}about/dashboard-dark.png`"/>
      <p class="log-in-to-get-started-now">
        <router-link
            class="login-link"
            :to="{ name: defaultCreateAccount? 'SignUpPage' : 'LogInPage'}"
            v-text="defaultCreateAccount? 'Sign up' : 'Sign in'">
        </router-link> to get started now.
      </p>
    </div>


    <!--        detail modals -->
    <div class="mol-center-card-width feature-section">
      <h4 class="feature-section-title text-my-oscar-list"><img :src="`${$imagePathBase}win_icon.svg`" alt="Logo" class="logo-image">GET<span class="text-oscar">THE</span>DETAILS</h4>
      <div class="row">
        <div class="col-6">
          <ColorThemeImg class="film-details-image" :src="`${$imagePathBase}about/film-details.png`" :dark_theme_src="`${$imagePathBase}about/film-details-dark.png`"/>
          <div style="margin-top: 1em;">
            <p><img class="checkmark-image" :src="`${$imagePathBase}win_icon.svg`"> Explore each film's nominations and wins.</p>
            <p>Follow a nomination's link to see which other films were competing in that category.</p>
          </div>
        </div>
        <div class="col-6">
          <p>Dive into the details of each film, including a short description, genres, running time, and if this film is in a foreign language.</p>
          <ColorThemeImg class="film-details-image" :src="`${$imagePathBase}about/category-details.png`" :dark_theme_src="`${$imagePathBase}about/category-details-dark.png`"/>
        </div>
      </div>

      <p class="log-in-to-get-started-now">
        <router-link
            class="login-link"
            :to="{ name: defaultCreateAccount? 'SignUpPage' : 'LogInPage'}"
            v-text="defaultCreateAccount? 'Sign up' : 'Sign in'">
        </router-link> to get started now.
      </p>
    </div>


    <!--        viewing options -->
    <div class="mol-center-card-width feature-section">
      <h4 class="feature-section-title text-my-oscar-list"><img :src="`${$imagePathBase}win_icon.svg`" alt="Logo" class="logo-image">FIND<span class="text-oscar">YOUR</span>FILMS</h4>
      <div class="row">
        <div class="col-6">
          <ColorThemeImg class="viewing-options-image" :src="`${$imagePathBase}about/viewing-options.png`" :dark_theme_src="`${$imagePathBase}about/viewing-options-dark.png`"/>
        </div>

        <div class="col-6">
          <div style="margin-top: 1em;">
            <p>Find nominated films in your cable schedule and streaming services.</p>
            <div class="row find-your-films-logos">
              <div v-for="(imgNames) in streamingServiceLogoImages" :key="imgNames.light" class="col-4 find-your-films-logo">
                <ColorThemeImg class="streaming-service-logo-image" :src="`${$imagePathBase}logos/content-providers/large-logos/${imgNames.light}`" :dark_theme_src="`${$imagePathBase}logos/content-providers/large-logos/${imgNames.dark}`"/>
              </div>
<!--              <div class="local-theaters">-->
<!--                <ColorThemeImg class="local-theaters-logo-image" :src="`${$imagePathBase}logos/content-providers/large-logos/local-theaters.svg`" :dark_theme_src="`${$imagePathBase}logos/content-providers/large-logos/local-theaters-dark.svg`"/>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>

      <p class="log-in-to-get-started-now">
        <router-link
            class="login-link"
            :to="{ name: defaultCreateAccount? 'SignUpPage' : 'LogInPage'}"
            v-text="defaultCreateAccount? 'Sign up' : 'Sign in'">
        </router-link> to get started now.
      </p>
    </div>

    <div class="mol-center-card-width feature-section">
      <h4 class="feature-section-title text-my-oscar-list"><img :src="`${$imagePathBase}win_icon.svg`" alt="Logo" class="logo-image">START<span class="text-oscar">YOUR</span>LIST</h4>
      <div style="text-align: center;">
        <router-link class="btn btn-primary btn-login" to="/log-in">
          log in
        </router-link>
        to get started now.
      </div>
    </div>

  </section> <!-- container -->
</template>


<script>



  import LogoSvg from "@/components/icons/LogoSvg.vue";
  import ColorThemeImg from "@/components/ColorThemeImg.vue";

  export default {
    name: "WelcomePage",
    components: {
      // eslint-disable-next-line
      ColorThemeImg,
      LogoSvg
    },
    computed: {

      defaultCreateAccount() {
        return (this.$route.query['new-acct'] === 'true' ||
            Object.hasOwn(this.$route.query, 'utm_source') || Object.hasOwn(this.$route.query, 'utm-source') ||
            Object.hasOwn(this.$route.query, 'fbclid'));
      },

      streamingServiceLogoImages() {
        return [
            // cable schedules
            { light: "tcm-logo.svg", dark: "tcm-logo-dark.svg" },
            { light: "amc-logo.svg", dark: "amc-logo-dark.svg" },

            // most popular
            { light: "hbo-max-logo.svg", dark: "hbo-max-logo-dark.svg" },
            { light: "netflix-logo.svg", dark: "netflix-logo.svg" },
            { light: "prime-video-logo.svg", dark: "prime-video-logo-dark.svg" },
            { light: "hulu-logo.svg", dark: "hulu-logo.svg" },
            { light: "paramount-plus-logo.svg", dark: "paramount-plus-logo-dark.svg" },
            { light: "disney-plus-logo.svg", dark: "disney-plus-logo-dark.svg" },
            { light: "peacock-logo.svg", dark: "peacock-logo-dark.svg" },
            { light: "apple-tv-logo.svg", dark: "apple-tv-logo-dark.svg" },

            // niche cinephile
            { light: "criterion-channel-logo.svg", dark: "criterion-channel-logo-dark.svg" },
            { light: "mubi-logo.svg", dark: "mubi-logo-dark.svg" },
            { light: "shorts-tv-logo.svg", dark: "shorts-tv-logo-dark.svg" },
            { light: "kanopy-logo.svg", dark: "kanopy-logo-dark.svg" },

            // theaters
            { light: "local-theaters-alt.svg", dark: "local-theaters-alt-dark.svg" },
        ];
      }
    },
    created() {
      //console.log('query params [created()]', this.$route.query);
      this.$colorTheme.setTheme(this.$route.query['color-theme']);
    },
    mounted() {
      //console.log('query params', this.$route.query);
    },
    methods: {
    }
  }

</script>


<style scoped>

.top-title {
  color: var(--mol-color-gold-text);
  text-align: center;
  margin-top: 10px;
  margin-bottom: 20px;

  .logo-themed-header {
    font-size: xxx-large;

    svg {
      height: 1.125em;
      margin-right: 0.1em;
      margin-top: -0.1275em;
    }
  }
}

.login-link {
  text-decoration: none;
}

.feature-section {

  color: var(--mol-color-gold-text);


  .feature-section-title {
    color: var(--mol-color-gold-text);
    text-align: center;
    margin-top: 0.5em;
    margin-bottom: 1em;
  }

  overflow: hidden;
  margin-bottom: 40px;


  border: none;
  border-top: solid;
  border-width: 0.1px;
  border-color: var(--mol-color-gold);
  padding: 20px;

  &.feature-section-checklist {
  }

  &.feature-section-dashboard {
  }
}

.log-in-to-get-started-now {

  a {
    font-weight: bold;
  }

  width: fit-content;
  margin-left: auto;
  margin-right: auto;

  margin-top: 2em;
  text-align: center;
}

/* we use the :deep() selector to make sure this class is applied inside the ColorThemeImg component */
:deep(.checklist-image) {
  border: solid;
  border-width: thin;
  border-color: var(--bs-border-color-translucent);
  border-radius: 5px;

  width: 80%;
  display: block;
  margin-top: 2em;
  margin-left: auto;
  margin-right: auto;
}

.checklist-bullet-list {
  margin-top: 2em;
  margin-left: auto;
  margin-right: auto;
  max-width: 360px;
}

:deep(.dashboard-image) {
  border: solid;
  border-width: thin;
  border-color: var(--bs-border-color-translucent);
  border-radius: 5px;

  width: 80%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1em;
  margin-bottom: 1em;
}

.dashboard-text {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  max-width: 300px;
}

:deep(.film-details-image) {
  border: solid;
  border-width: thin;
  border-color: var(--bs-border-color-translucent);
  border-radius: 5px;

  width: 100%;
}

.checkmark-image {
  height: 1.125em;
}

:deep(.viewing-options-image) {
  width: 100%;
}

:deep(.streaming-service-logo-image) {
  width: 80%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-style: none;
}

:deep(.local-theaters-logo-image) {
  opacity: 90%;
  margin-bottom: 30px;
  width: 90%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}


.text-my-oscar-list {
  font-weight: 300;

  .text-oscar {
    font-weight: 600;
    padding-left: 0.05em;
    padding-right: 0.05em;
  }

  img {
    height: 1em;
    margin-right: 0.1em;
    margin-top: -0.2em;
  }
}

.find-your-films-logos {
  margin-top: 2em;

  .find-your-films-logo {
    margin-bottom: 20px;
    height: 40px;
  }

}



</style>